import moment from "moment";
import React from "react";
import * as Comp from "../../../components";
import * as M from "../../../models";
import { Utility } from "../../../utils";

interface OwnProps {
    isFullPage?: boolean;
    isPreview?: boolean;
    job: M.CareerCenter.JobPost;
    onTitleClick?: (job: M.CareerCenter.JobPost) => void;
    routePath?: string;
    showExpires?: boolean;
}

interface OwnState {
}

export class JobDetailsPartial extends React.Component<OwnProps, OwnState> {

    public render() {
        const job = this.props.job;
        const desc = job.descriptionNoHtml;
        const title = this.props.isPreview
            ? <a href="#" onClick={(e) => this.handleTitleClick(e)}>{job.title}</a>
            : job.title;

        let expiresDisplay = null;
        if (this.props.showExpires && job.expiresOn) {
            const expiresOn = Utility.utcToLocal(job.expiresOn);
            expiresDisplay = new Date() > expiresOn
                ? <li><strong>Expired {moment(expiresOn).format("MMM D, YYYY")}</strong></li>
                : <li>Expires {moment(expiresOn).format("MMM D, YYYY")}</li>;
        }

        const details = this.props.isPreview
            ? <div className="jobs-preview">{desc && desc.length > 200 ? (desc.substr(0, 200) + "...") : desc}</div>
            : <div className="jobs-description">
                <dl>
                    <dt>Description</dt>
                    <dd dangerouslySetInnerHTML={{ __html: job.description || "Not available" }} />

                    <dt>How to apply</dt>
                    <dd dangerouslySetInnerHTML={{ __html: job.howToApply || "Not available" }} />
                </dl>
            </div>;

        return <Comp.Generic.WrapperLess>
            <h3 className="jobs-title">
                {title}
            </h3>

            <h3 className="jobs-location">
                {job.organization} &ndash; {M.Generic.AddressHelper.displayCityStateInline(job.location, "name", false)}
            </h3>

            <ul className="jobs-summary">
                <li>Posted {moment(Utility.fromApiDate(job.postedOn)).format("MMM D, YYYY")}</li>
                {expiresDisplay}
            </ul>

            {details}
        </Comp.Generic.WrapperLess>;
    }

    private handleTitleClick(e: React.MouseEvent<HTMLAnchorElement>) {
        if (this.props.onTitleClick)
            this.props.onTitleClick(this.props.job);

        e.preventDefault();
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/jobDetails/JobDetailsPartial.tsx